import firebase from 'firebase/app';
import { ApprovalInfo } from './approval/approval';

export interface CourseData {
  name: string;
  field: Field;
  instructorIds: string[];
  archived: boolean;
  frozen: boolean;
  description: string;
  prereqNotes: string;
  zoomLink: string;
  courseLevel: CourseLevel;
  studentCountInfo: StudentCountInfo;
  gradeInfo: GradeInfo;
  sections: SectionInfo[];
  curriculumFiles: FileInfo[];
  courseApprovalRef: firebase.firestore.DocumentReference<ApprovalInfo>;
  curriculumApprovalRef: firebase.firestore.DocumentReference<ApprovalInfo>;
}

export enum Field {
  CompSciEng = 'Computer Science and Engineering',
  Humanities = 'Humanities and Social Sciences',
  SciMath = 'Science and Math',
  Lifestyle = 'Special Skills and Lifestyle',
  Arts = 'Arts',
  WorldLang = 'World Languages',
}

export enum CourseLevel {
  OneHundred = '100',
  TwoHundred = '200',
}

export interface StudentCountInfo {
  recommended: number;
  max: number;
}

export interface GradeInfo {
  regular: GradeRange;
  exception: GradeRange;
}

export interface GradeRange {
  min: number;
  max: number;
}

export interface SectionInfo {
  meetings: TimeDayPair[];
  timeZone: TimeZone;
}

export interface TimeDayPair {
  day: DayOfTheWeek;
  time: string;
}

export enum DayOfTheWeek {
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
}

export interface FileInfo {
  filename: string;
  url: string;
}

export enum TimeZone {
  'Etc/GMT+12' = 'International Date Line West',
  'Pacific/Midway' = 'Midway Island, Samoa',
  'Pacific/Honolulu' = 'Hawaii',
  'US/Alaska' = 'Alaska',
  'America/Los_Angeles' = 'Pacific Time (US & Canada)',
  'America/Tijuana' = 'Tijuana, Baja California',
  'US/Arizona' = 'Arizona',
  'America/Chihuahua' = 'Chihuahua, La Paz, Mazatlan',
  'US/Mountain' = 'Mountain Time (US & Canada)',
  'America/Managua' = 'Central America',
  'US/Central' = 'Central Time (US & Canada)',
  'America/Mexico_City' = 'Guadalajara, Mexico City, Monterrey',
  'Canada/Saskatchewan' = 'Saskatchewan',
  'America/Bogota' = 'Bogota, Lima, Quito, Rio Branco',
  'US/Eastern' = 'Eastern Time (US & Canada)',
  'US/East-Indiana' = 'Indiana (East)',
  'Canada/Atlantic' = 'Atlantic Time (Canada)',
  'America/Caracas' = 'Caracas, La Paz',
  'America/Manaus' = 'Manaus',
  'America/Santiago' = 'Santiago',
  'Canada/Newfoundland' = 'Newfoundland',
  'America/Sao_Paulo' = 'Brasilia',
  'America/Argentina/Buenos_Aires' = 'Buenos Aires, Georgetown',
  'America/Godthab' = 'Greenland',
  'America/Montevideo' = 'Montevideo',
  'America/Noronha' = 'Mid-Atlantic',
  'Atlantic/Cape_Verde' = 'Cape Verde Is.',
  'Atlantic/Azores' = 'Azores',
  'Africa/Casablanca' = 'Casablanca, Monrovia, Reykjavik',
  'Etc/Greenwich' = 'Greenwich Mean Time: Dublin, Edinburgh, Lisbon, London',
  'Europe/Amsterdam' = 'Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
  'Europe/Belgrade' = 'Belgrade, Bratislava, Budapest, Ljubljana, Prague',
  'Europe/Brussels' = 'Brussels, Copenhagen, Madrid, Paris',
  'Europe/Sarajevo' = 'Sarajevo, Skopje, Warsaw, Zagreb',
  'Africa/Lagos' = 'West Central Africa',
  'Asia/Amman' = 'Amman',
  'Europe/Athens' = 'Athens, Bucharest, Istanbul',
  'Asia/Beirut' = 'Beirut',
  'Africa/Cairo' = 'Cairo',
  'Africa/Harare' = 'Harare, Pretoria',
  'Europe/Helsinki' = 'Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
  'Asia/Jerusalem' = 'Jerusalem',
  'Europe/Minsk' = 'Minsk',
  'Africa/Windhoek' = 'Windhoek',
  'Asia/Kuwait' = 'Kuwait, Riyadh, Baghdad',
  'Europe/Moscow' = 'Moscow, St. Petersburg, Volgograd',
  'Africa/Nairobi' = 'Nairobi',
  'Asia/Tbilisi' = 'Tbilisi',
  'Asia/Tehran' = 'Tehran',
  'Asia/Muscat' = 'Abu Dhabi, Muscat',
  'Asia/Baku' = 'Baku',
  'Asia/Yerevan' = 'Yerevan',
  'Asia/Kabul' = 'Kabul',
  'Asia/Yekaterinburg' = 'Yekaterinburg',
  'Asia/Karachi' = 'Islamabad, Karachi, Tashkent',
  'Asia/Calcutta' = 'Chennai, Kolkata, Mumbai, New Delhi',
  'Asia/Katmandu' = 'Kathmandu',
  'Asia/Almaty' = 'Almaty, Novosibirsk',
  'Asia/Dhaka' = 'Astana, Dhaka',
  'Asia/Rangoon' = 'Yangon (Rangoon)',
  'Asia/Bangkok' = 'Bangkok, Hanoi, Jakarta',
  'Asia/Krasnoyarsk' = 'Krasnoyarsk',
  'Asia/Hong_Kong' = 'Beijing, Chongqing, Hong Kong, Urumqi',
  'Asia/Kuala_Lumpur' = 'Kuala Lumpur, Singapore',
  'Asia/Irkutsk' = 'Irkutsk, Ulaan Bataar',
  'Australia/Perth' = 'Perth',
  'Asia/Taipei' = 'Taipei',
  'Asia/Tokyo' = 'Osaka, Sapporo, Tokyo',
  'Asia/Seoul' = 'Seoul',
  'Asia/Yakutsk' = 'Yakutsk',
  'Australia/Adelaide' = 'Adelaide',
  'Australia/Darwin' = 'Darwin',
  'Australia/Brisbane' = 'Brisbane',
  'Australia/Canberra' = 'Canberra, Melbourne, Sydney',
  'Australia/Hobart' = 'Hobart',
  'Pacific/Guam' = 'Guam, Port Moresby',
  'Asia/Vladivostok' = 'Vladivostok',
  'Asia/Magadan' = 'Magadan, Solomon Is., New Caledonia',
  'Pacific/Auckland' = 'Auckland, Wellington',
  'Pacific/Fiji' = 'Fiji, Kamchatka, Marshall Is.',
  'Pacific/Tongatapu' = "Nuku'alofa",
}
